import {ContentBox} from '@hconnect/common/components/ContentBox'
import {useExpandedGroups} from '@hconnect/common/hooks/useExpandGroups'
import {EquipmentPerformance, KpiCalculationTimeFrameDto} from '@hconnect/common/types'
import {ExpandCollapseButton} from '@hconnect/uikit/src/lib2'
import {Box} from '@mui/material'
import {EquipmentKpiCardsOverview, EquipmentKpiTableOverview} from '@widgets/kpis'
import {isEmpty} from 'lodash'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type PerformanceSummaryProps = {
  isLoading: boolean
  'data-test-id': string
  equipmentPerformances?: EquipmentPerformance[]
  timeFrames: KpiCalculationTimeFrameDto[]
  isDesktop: boolean
}

export const PerformanceSummary: FC<PerformanceSummaryProps> = ({
  isLoading,
  equipmentPerformances,
  timeFrames,
  'data-test-id': dataTestId,
  isDesktop
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const equipmentIndexes: string[] = Array.from(
    {length: equipmentPerformances?.length || 0},
    (_, index) => String(index)
  )
  const [expandedEquipments, toggleExpandedEquipments] = useExpandedGroups(
    equipmentIndexes,
    'summary-expanded-equipments'
  )

  if (isDesktop || isLoading) {
    return (
      <ContentBox
        title={
          !isEmpty(equipmentPerformances) && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              flexWrap="wrap"
              gap={1}
            >
              <Box display="flex" alignItems="center" flexWrap="wrap">
                <ExpandCollapseButton
                  variant="text"
                  expanded={
                    expandedEquipments && expandedEquipments.length === equipmentIndexes.length
                  }
                  onClick={() => toggleExpandedEquipments('all')}
                  data-test-id="performance-expand-all-button"
                  expandLabel={t('action.expand')}
                  collapseLabel={t('action.collapse')}
                />
              </Box>
            </Box>
          )
        }
        mode="contentDependentHeight"
        bodyWithPadding
        isLoading={isLoading}
        minHeight={isDesktop ? '450px' : '88px'}
        data-test-id={dataTestId}
      >
        {equipmentPerformances && (
          <EquipmentKpiTableOverview
            data={equipmentPerformances}
            expandedEquipments={expandedEquipments}
            toggleExpandedEquipments={toggleExpandedEquipments}
            timeFrames={timeFrames}
          />
        )}
      </ContentBox>
    )
  }

  return equipmentPerformances ? (
    <EquipmentKpiCardsOverview
      data={equipmentPerformances}
      expandedEquipments={expandedEquipments}
      toggleExpandedEquipments={toggleExpandedEquipments}
      timeFrames={timeFrames}
      cardBoxSx={{mb: 2}}
    />
  ) : null
}
